import React, { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX, SkipForward } from 'lucide-react';

const VIDEO_URL =
  'https://customer-assets-jt897jd0.emergentagent.net/job_scroll-visual-design/artifacts/hxnry73i_Final%20Intro%20Video.MP4';

export default function IntroVideo() {
  // Show once per browser session
  const [show, setShow] = useState(() => {
    try {
      return sessionStorage.getItem('nk_intro_seen') !== '1';
    } catch {
      return true;
    }
  });
  const [closing, setClosing] = useState(false);
  const [muted, setMuted] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  const finish = () => {
    setClosing(true);
    try {
      sessionStorage.setItem('nk_intro_seen', '1');
    } catch {}
    setTimeout(() => {
      setShow(false);
      document.body.style.overflow = '';
    }, 800);
  };

  const toggleSound = () => {
    const v = videoRef.current;
    if (!v) return;
    const next = !muted;
    v.muted = next;
    setMuted(next);
    if (!next) {
      // ensure it keeps playing after unmute
      v.play().catch(() => {});
    }
  };

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-black transition-opacity duration-700 ${
        closing ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <video
        ref={videoRef}
        src={VIDEO_URL}
        autoPlay
        muted={muted}
        playsInline
        onEnded={finish}
        className="w-full h-full object-cover"
      />

      {/* Golden vignette frame */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          boxShadow: 'inset 0 0 160px 40px rgba(0,0,0,0.55)',
        }}
      />

      {/* Controls */}
      <div className="absolute top-5 right-5 flex items-center gap-3">
        <button
          onClick={toggleSound}
          aria-label={muted ? 'Unmute' : 'Mute'}
          className="flex items-center gap-2 px-4 py-2 rounded-full font-heading text-sm tracking-wide text-[#f2d68a] bg-black/40 backdrop-blur-md border border-[#d9a63b]/60 hover:bg-black/60 transition"
        >
          {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
          {muted ? 'Tap for Sound' : 'Sound On'}
        </button>
        <button
          onClick={finish}
          aria-label="Skip intro"
          className="flex items-center gap-2 px-4 py-2 rounded-full font-heading text-sm tracking-wide text-[#fff8e7] bg-[#7c130f]/80 backdrop-blur-md border border-[#d9a63b]/70 hover:bg-[#a71c14] transition"
        >
          Skip Intro <SkipForward size={16} />
        </button>
      </div>
    </div>
  );
}
